import React, {Component} from 'react';
import './DepartmentFileUploads.scss';
import UploadedFile from "./UploadedFile";
import FileUploader from "../../../shared/forms/FIleUploader";
import Modal from '../../../shared/ui/Modal';
import {FormGroup, Input, Label, ModalBody, ModalFooter} from 'reactstrap';
import Checkbox from "../../../shared/forms/Checkbox";

const getFileName = (document) => {
  if (document.file && document.file.displayName) {
    return document.file.displayName;
  }

  let segments = document.file.name.split('/');
  return segments[segments.length - 1];
};

class DepartmentFileUploads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRoles: null,
      isEditFilePermissionOpen: false,
      selectedFile: null,
      selectedFileName: '',
      nextPositionIndex: null,
      selectedFileIndex: null,
      isDropped: true,
      nextPositionPlaceholder: '',
      destinationFolderIndex: null,
    }
  }

  get filterFiles() {
    if (this.props.uploadedDocuments.length) {
      let files = this.props.uploadedDocuments.filter(obj => obj.file.type === 'FILE' || obj.file.type === undefined);

      return files.filter(file => {
        return !file.file.roles
          || this.props.userContext.scope === 'depadmin'
          || (file.file.roles && file.file.roles.includes(this.props.userContext.scope));
      });
    }

    return [];
  }

  closeModal() {
    this.props.onPermissionsModalClose();

    this.setState({
      selectedRoles: null,
      isEditFilePermissionOpen: false
    });
  }

  onRoleSelect(e, role) {
    let selectedRoles = this.state.selectedRoles !== null ? this.state.selectedRoles : this.props.roles;

    if (e.target.checked) {
      selectedRoles = [...selectedRoles.filter(r => r !== role), role];
    } else {
      selectedRoles = selectedRoles.filter(r => r !== role);
    }

    this.setState({
      selectedRoles
    });
  }

  isRoleSelected(role) {
    if (this.state.selectedRoles) {
      return this.state.selectedRoles.includes(role);
    }
    else {
      return true;
    }
  }

  handleBlur(event) {
    const { name, value } = event.target;
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  createFile(selectedRoles) {
    if (this.state.isEditFilePermissionOpen) {
      const fileObj = {
        name: this.state.selectedFile.file.name,
        displayName: this.state.selectedFileName,
        type: 'FILE',
        roles: selectedRoles
      }

      this.props.onEditFilePermissions(fileObj, this.state.selectedFile);

      this.setState({
        selectedRoles: null,
        isEditFilePermissionOpen: false
      });
    }
    else {
      this.props.onCreateClick(selectedRoles);
    }
  }

  editPermissionsUploadedFile(file) {
    let selectedRoles = null;
    if (file.file.roles) {
      selectedRoles = file.file.roles;
    }

    this.setState({
      isEditFilePermissionOpen: true,
      selectedFile: file,
      selectedFileName: getFileName(file),
      selectedRoles
    });
  }

  handleDrop(e) {
    if (this.state.nextPositionIndex !== null) {
      this.props.onUpdateUploadedDocumentsList(this.filterFiles[this.state.nextPositionIndex],
        this.filterFiles[this.state.selectedFileIndex]);
    }
    else if (this.state.destinationFolderIndex >= 0) {
      this.props.onMoveFileToFolder(this.state.destinationFolderIndex);
    }

    this.props.onFileDragStartEnd(null);

    this.setState({
      selectedFileIndex: null,
      nextPositionIndex: null,
      destinationFolderIndex: null,
      isDropped: true
    })

    document.body.style.overflow = "auto";
  }

  handleMove(indexPosition, id, className, positionX) {
    let elem = document.getElementById(id);
    let isFolder = document.getElementById(id);
    if (!elem) {
      elem = document.getElementsByClassName(className)[0];

      if (elem && elem.className !== 'file-wrapper') {
        for (let i = 0; i < 10; i++) {
          if (elem) {
            elem = elem.parentElement;

            if (elem && elem.className === 'file-wrapper') {
              break;
            }
          }
        }
      }
    }

    this.props.onOverFolder(-1);

    if (elem) {
      let fileElement = elem.getBoundingClientRect();
      const leftRightMargin = fileElement.width * 0.3;
      const centerMargin = fileElement.width * 0.3;

      if (Math.abs(fileElement.right - positionX) <= leftRightMargin && indexPosition > this.state.selectedFileIndex
        && !isFolder) {
        // move after elemet (left to right move)

        this.setState({
          nextPositionIndex: indexPosition,
          nextPositionPlaceholder: 'right',
          destinationFolderIndex: null,
        })
      }
      else if (Math.abs(fileElement.right - positionX) <= leftRightMargin && (this.state.selectedFileIndex - 1) > indexPosition
        && !isFolder) {
        // move after elemet (right to left move)

        this.setState({
          nextPositionIndex: parseInt(indexPosition) + 1,
          nextPositionPlaceholder: 'left',
          destinationFolderIndex: null,
        })
      }
      else if (Math.abs(fileElement.left - positionX) <= leftRightMargin && indexPosition < this.state.selectedFileIndex
        && !isFolder) {
        // move before element (right to left move)

        this.setState({
          nextPositionIndex: indexPosition,
          nextPositionPlaceholder: 'left',
          destinationFolderIndex: null,
        })
      }
      else if (Math.abs(fileElement.left - positionX) <= leftRightMargin && (indexPosition -1) > this.state.selectedFileIndex
        && !isFolder) {
        // move before element (left to right move)

        this.setState({
          nextPositionIndex: parseInt(indexPosition) - 1,
          nextPositionPlaceholder: 'right',
          destinationFolderIndex: null,
        })
      }
      else if (Math.abs(Math.abs((fileElement.left + fileElement.right) / 2) - positionX) <= centerMargin && isFolder) {
        // place it inside

        this.setState({
          nextPositionIndex: null,
          nextPositionPlaceholder: '',
          destinationFolderIndex: parseInt(indexPosition)
        })

        this.props.onOverFolder(parseInt(indexPosition));
      }
      else {
        // reset

        this.setState({
          nextPositionIndex: null,
          nextPositionPlaceholder: '',
          destinationFolderIndex: null,
        })
      }
    }
    else {
      // reset

      this.setState({
        nextPositionIndex: null,
        nextPositionPlaceholder: '',
        destinationFolderIndex: null,
      })
    }
  }

  handleDragOver(e) {
    let index = e.target.id.split('file-');

    if (index.length <= 1) {
      index = e.target.className.split('file-index-');
    }

    if (index.length > 1) {
      index = parseInt(index[1]);
      if (!Number.isInteger(index)) {
        index = null;
      }
    }
    else {
      index = null;
    }

    this.handleMove(index, e.target.id, e.target.className, e.clientX);
  }

  handleDragStart(fileIndex) {
    if (this.state.isDropped) {
      this.props.onFileDragStartEnd(this.filterFiles[fileIndex]);

      this.setState({
        selectedFileIndex: fileIndex,
        isDropped: false,
        destinationFolderIndex: null
      })
    }
  }

  handleDragEnd(e) {
    this.props.onFileDragStartEnd(null);

    this.setState({
      isDropped: true,
      destinationFolderIndex: null
    })
  }

  handleTouchMove(e) {
    if (this.props.userContext.hasScope('depadmin')) {
      const target = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY)
      let index = target.id.split('file-');

      if (index.length <= 1) {
        index = target.className.split('file-index-');
      }

      if (index.length > 1) {
        index = parseInt(index[1]);
        if (Number.isInteger(index)) {
          this.handleMove(index, target.id, target.className, e.touches[0].clientX);
        }
      }
    }
  }

  displayNewPosition(index) {
    if (this.state.nextPositionIndex == index) {
      return this.state.nextPositionPlaceholder;
    }

    return '';
  }

  render() {
    return (
      <div className="file-uploads-container">
        <div className="files-container">
            {this.filterFiles.length > 0 &&
              <h4>Files</h4>
            }

            {this.filterFiles.length > 0 &&
              <div className="files-list"
                onDrop={(e) => this.handleDrop(e)}
                onTouchEnd ={(e) => this.handleDrop(e)}
                onDragOver={(e) => this.handleDragOver(e)}
                onTouchMove={(e) => this.handleTouchMove(e)}
              >
                {this.filterFiles.map((document, index) => (
                  <UploadedFile
                    key={document.id}
                    index={index}
                    file={document}
                    placeholderClass={this.displayNewPosition(index)}
                    canDelete={this.props.userContext.hasScope('depadmin')}
                    onDelete={file => this.props.onDeleteUploadedFile(file)}
                    onEditPermissions={file => this.editPermissionsUploadedFile(file)}
                    onDragStart={(fileIndex) => this.handleDragStart(fileIndex)}
                    onDragOver={e => this.handleDragOver(e)}
                    onDragEnd={e => this.handleDragEnd(e)}
                    onHandleMove={(indexPosition, id, className, positionX) => this.handleMove(indexPosition, id, className, positionX)}
                  />
                ))}

                {this.props.userContext.hasScope('depadmin') &&
                  <FileUploader
                    onUpload={file => this.props.onUploadDocument(file)}
                    departmentGuid={this.props.userContext.departmentGuid} />
                }
              </div>
            }

            {this.filterFiles.length === 0 && this.props.userContext.hasScope('depadmin') &&
              <div className="no-files">
                <FileUploader
                  onUpload={file => this.props.onUploadDocument(file)}
                  departmentGuid={this.props.userContext.departmentGuid} />
              </div>
            }
        </div>

        <Modal
          isOpen={this.props.isManageFilePermissionOpen || this.state.isEditFilePermissionOpen}
          title="Manage file permission"
          onClose={() => this.closeModal()}
        >
          <ModalBody>
            {this.state.isEditFilePermissionOpen &&
              <FormGroup>
                <Label for="selectedFileName">File Name *</Label>

                <Input
                  name="selectedFileName"
                  onBlur={event => this.handleBlur(event)}
                  onChange={event => this.handleInput(event)}
                  type="text"
                  value={this.state.selectedFileName}
                />
              </FormGroup>
            }

            <FormGroup>
              <Label for="folderName">Who can view this file?</Label>

              {this.props.rolesOptionsTranslated && this.props.rolesOptionsTranslated.map(role => (
                <Checkbox checked={this.isRoleSelected(role.scope)} onChange={e => this.onRoleSelect(e, role.scope)}
                  label={role.name} key={role.scope} />
              ))}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <button
              className="button secondary"
              onClick={() => this.createFile(this.state.selectedRoles)}
            >
              {this.state.isEditFilePermissionOpen &&
                <span>Update</span>
              }

              {!this.state.isEditFilePermissionOpen &&
                <span>Save</span>
              }
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default DepartmentFileUploads
